export default {
  email: { id: 'email' },
  submit: { id: 'submit' },
}
